@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.business.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.business.resources/"

@delegate:ResourceContentHash(587_756_253)
internal val Res.string.weekday_sat: StringResource by lazy {
      StringResource("string:weekday_sat", "weekday_sat", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15660, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12848, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11436, 23),
      ))
    }

@delegate:ResourceContentHash(2_020_120_193)
internal val Res.string.weekday_sun: StringResource by lazy {
      StringResource("string:weekday_sun", "weekday_sun", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15692, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12872, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11460, 23),
      ))
    }

@delegate:ResourceContentHash(-1_744_757_649)
internal val Res.string.weekday_thu: StringResource by lazy {
      StringResource("string:weekday_thu", "weekday_thu", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15728, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12896, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11484, 23),
      ))
    }

@delegate:ResourceContentHash(2_082_884_734)
internal val Res.string.weekday_tue: StringResource by lazy {
      StringResource("string:weekday_tue", "weekday_tue", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15768, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12920, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11508, 23),
      ))
    }

@delegate:ResourceContentHash(746_956_603)
internal val Res.string.weekday_wed: StringResource by lazy {
      StringResource("string:weekday_wed", "weekday_wed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 15808, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12944, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11532, 23),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("weekday_sat", Res.string.weekday_sat)
  map.put("weekday_sun", Res.string.weekday_sun)
  map.put("weekday_thu", Res.string.weekday_thu)
  map.put("weekday_tue", Res.string.weekday_tue)
  map.put("weekday_wed", Res.string.weekday_wed)
}
